<template>
    <div id="VendorList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Vendor List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link v-if="canAddVendor" class="btn btn-primary" v-bind:to="{name: 'VendorCreate'}" > <i class="fp-add"></i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'vendorList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :moduleName="'vendorList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listVendorTable"
                                      mode="remote"
                                      title="Vendor"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      @on-select-all="onSelectAll"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: vendor_value,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <template v-if="canUpdateVendor">
                                                      <router-link title="Edit Vendor" class="fp-edit" v-bind:to="{name: 'VendorEdit',params:{id:props.row.id}}"></router-link>
                                                  </template>
                                              </div>
                                              <div v-else-if="props.column.field == 'list_in'">
                                                  <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                              </div>
                                              <div v-else-if="props.column.field == 'previous_gl'">
                                                <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                              </div>
                                              <div v-else-if="props.column.field == 'vendor_code'">
                                                  <router-link v-if="canViewVendor" title="View Vendor" class="color-blue" v-bind:to="{name: 'VendorView',params:{id:props.row.id}}">{{props.row.vendor_code}}</router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button v-if="vendor_value" id="deleteVendorBtn" v-on:click.prevent="VendorDelete" class="btn btn-primary">Delete</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                        <div class="modal fade vendor-message-modal" id="vendor-message-modal" ref="vendorMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="vendorMessageModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Message</h5>
                                        <button type="button" class="close" id="btnModalMessageClose" v-on:click="hideMessageModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <p>Following Vendor Already in Use : </p>
                                        <template v-if="vendorUsedArr.length > 0">
                                            <template v-for="(row,key) in vendorUsedArr">
                                                <p :key="key">Vendor Name : {{row.vendor}}&nbsp;&nbsp;</p>
                                                    <template v-if="row.vendor_used_in.length > 0">
                                                        <p :key="'vendor_use'+key">
                                                        Vendor Used In :
                                                        <template v-for="(used_in,index) in row.vendor_used_in">
                                                            <a :key="'i' + index" v-if="index > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'j' + index"> {{used_in}}</span>
                                                        </template>
                                                        </p>
                                                    </template>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade part-upload-modal" id="part-upload-modal" ref="part-upload-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="part-upload-modal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importIFTAFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require mb-2" for="name">File:</label><br/>
                                                    <input id="partUploadFile" type="file" @change="onFileChanged">
                                                    <div class="field-error">{{import_error}}</div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col form-group" v-if="fileName != ''">
                                                    <label class="control-label"> Download Sample file </label>
                                                    <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                </div>
                                            </div>

                                            <p v-if="importedCount > 0"><i class="fa fa-check" aria-hidden="true"></i> &nbsp;<strong>{{importedCount}} Records imported</strong></p> 
                                        </form>

                                        <div class="modal-footer">
                                            <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                            <button class="btn btn-primary" id="importButton" v-on:click="importParts()"> <i class="fp-import"> </i> Import</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>

import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
    export default {
        name: "VendorList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Vendor List  | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
             permissions: [],
            userColumns:[],
            cantAccessPage: "",
            columns: [
                {
                    label: 'Actions',
                    hidden:false,
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Vendor Code',
                    field: 'vendor_code',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Vendor Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Phone',
                    field: 'phone',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Phone Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contact Name',
                    field: 'contact_name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contact Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'State',
                    field: 'state',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "State Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'City',
                    field: 'city',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "City Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Zip',
                    field: 'zip',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
//                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Zip", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Monthly Payable',
                    field: 'monthly_payable',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Monthly Payable", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterDropdownItems:["Yes","No"]
                    }
                },
                {
                    label: 'Payment Type',
                    field: 'payment_type',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Payment Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterDropdownItems:["ACH","CHECK","COMCHECK","CREDIT CARD", "CH"]
                    }
                },
                {
                    label: 'Previous GL Account',
                    field: 'previous_gl',
                    fpFieldType:"text",
                    hidden:false,
                    html:true,
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "City Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                  label: 'Status',
                  field: 'status',
                  filterable: true,
                  fpFieldType:"option",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems:["active","inactive"]
                  }
                },
                // {
                //     label: 'List In',
                //     field: 'list_in',
                //     filterable: true,
                //     hidden:false,
                //     html: true,
                //     filterOptions: {
                //         enabled: true, // enable filter for this column
                //         placeholder: "Select", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         filterDropdownItems: ['Parts', 'Service','Fuel'],
                //         trigger: "enter" //only trigger on enter not on keyup
                //     },
                // },
            ],
            rows: [],
            totalRecords: 0,
            vendor_value: false,
            loading:false,
            action:'list',
            canViewVendor:false,
            canUpdateVendor:false,
            canAddVendor:false,
            pageKey:"_vendor_list_",
            vendorUsedArr:[],
            batchProcess:0,
            batchNum:"",
            importedCount:0,
            import_error:'',
            fileName:'',
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_vendor') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_vendor') {
                            self.canAddVendor = true;
                            self.canUpdateVendor = true;
                        }
                        if (permissions[i].name == 'view_vendor') {
                            self.canViewVendor = true;
                        }
                        if (permissions[i].name == 'delete_vendor') {
                            self.vendor_value = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },

        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listVendorTable.unselectAllInternal();
            },
            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('phone');
                    field:('contact_name');
                    field:('state');
                    field:('city');
                    field:('zip');
                    field:('list_in');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.phone || filters.contact_name || filters.state || filters.city || filters.zip || filters.list_in) {
                    this.loadList();
                }
            },*/
            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listVendorTable'].selectedRows;
                count = data.length;

                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                    page:1,
                });
                this.loadList();
            },*/
            loadList() {
                var self = this;

                var data = this.$refs['listVendorTable'].selectedRows;

                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listVendorTable'].selectedRows[i].id)
                }
                self.loading = true;

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    selectedRows:use,
                    sort: self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                    action:self.action,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/vendor/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                              if ( data.code == "201" ) {
                                  alert(data.message);
                              } else {
                                  if ( self.action == "export" ) {
                                      self.excel = data.content.web;
                                      var save = document.createElement("a");
                                      save.href = self.excel;
                                      save.download = data.content.web;
                                      save.target = "_blank";

                                      document.body.appendChild(save);
                                      save.click();
                                      document.body.removeChild(save);

                                  } else {

                                      self.batchProcess = 1;
                                      self.batchNum = data.content;
                                  }
                              }
                              self.action = "list";
                              self.loadList();

                            }else if (self.action == 'list') {

                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;

                            }else if (self.action == 'delete') {

                                self.action = 'list';
                                self.vendorUsedArr = [];
                                if (data.content.vendor_used && data.content.vendor_used.length > 0) {
                                    //vendor used message
                                    self.vendorUsedArr = data.content.vendor_used;
                                    $("#vendor-message-modal").modal("show");
                                }
                                self.loadList();
                            }
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (self.action == "delete") {
                            self.generateStatusCodeMessage(jqXHR,true,'vendor-delete');
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'vendor-list');
                        }
                    }
                });
            },
            VendorDelete() {

                //var data = this.$refs['listVendorTable'].selectedRows;
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Vendor?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.action = 'delete';
                        self.loadList();
                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete this Vendor? ')) {
                //
                // }
                return;
                // var use = [];
                // for (var i = 0; i < data.length; i++) {
                //     use.push(this.$refs['listVendorTable'].selectedRows[i].id)
                // }

                // if (confirm('Are you sure that you want to delete this Vendor? ')) {
                //     self.loading = true;
                //     $("#deleteVendorBtn").val("Deleting ...");
                //     $.ajax({
                //         url: process.env.ROOT_API + "/vendor/delete",
                //         type: "POST",
                //         data: 'id=' + use,
                //         headers: this.ajxHeaders,
                //         dataType: 'json',
                //         success: function (data) {
                //             self.loading = false;
                //             setTimeout(function () {
                //             $(".alert-success").removeClass("show");
                //                 $(".alert-success").addClass("hide");
                //             }, 10000);
                //             setTimeout(function () {
                //                 $("#deleteVendorBtn").val("Delete");
                //             }, 10000);
                //             self.rows = data.content.row;
                //             if (data.code == '200') {
                //                 self.rows = data.content.row;
                //                 self.totalRecords = data.content.totalRecords;
                //                 self.loadList();
                //             }
                //         },
                //         error: function (jqXHR, exception) {
                //             self.loading = false;
                //             self.generateStatusCodeMessage(jqXHR,true,'vendor-delete');
                //         }
                //     });
                // }
            },
            hideMessageModal() {
                var self = this;
                $("#vendor-message-modal").modal("hide");
                self.vendorUsedArr = [];
            },
            openModal: function(){
                let self = this;
                self.importedCount = 0;
                self.selectedFile = "";
                $("#partUploadFile").val('');
                self.import_error = '';
                self.generateExcelSample();
                $('#part-upload-modal').modal('show');
            },
            onFileChanged(event) {
                const file = event.target.files[0];
                let self = this;
                self.selectedFile = file;
                self.import_error = '';
            },
            generateExcelSample() {
                let self = this;
                $.ajax({
                    url:
                    process.env.ROOT_API + "/vendor-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    success: function(data) {
                        self.loading = false;
                        self.fileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'part-upload-generate')

                    }
                });
            },
            downloadSample(){
                let self = this;
                let docPath = self.file;
                let save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            importParts() {
                let self = this;
                self.import_error = "";
                
                if( self.selectedFile == "" || self.selectedFile == null){
                    self.import_error = "Please Select Excel File.";
                    return;
                }
                let fileExtension = ['xls', 'xlsx'];
                if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                    self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                    return;
                }

                let formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $('#cancelButton').prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/vendor-excel/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.import_error = '';
                        if (data.code == 400) {
                            self.import_error = data.message;
                            return;
                        }
                        if (data.status == "success") {

                            if ( Object.keys(data.duplicate).length > 0){

                                self.importedCount = data.content;

                            }else{
                                if(data.content != false){
                                    self.$swal('',data.content+" Records imported",'success');
                                }
                                $('#part-upload-modal').modal('hide');
                                self.loadList();
                            }

                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'part-upload-import-error')
                    }
                });
            },
        }
    };
</script>
<style scope>
.el-table .cell{
    white-space:pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/VendorList.vue